<template>
  <div @click="goToPage">
    <div
      class="card zoom text-black custom-card"
    >
      <img
        slot="image"
        class="card-img-top card-img bg-light custom-card-img"
        :src="item.imgSrc"
        alt="Card image cap"
      />
      <div class="card-body mx-4 mb-3">
        <h4 class="card-title text-left">
          <b>{{ item.title }}</b>
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
import VueRouter from "vue-router";
import router from "../../router";
import { config } from "../../utils/config";
export default {
  name: "card",
  props: ["item"],
  methods: {
    mounted() {
    },
    goToPage() {
      document.body.scrollTop = 0;

      if (router.history.current.name !== this.item.pageDestination) {
        if(config.isGeodidalab) {
          router.push({ path: this.item.pageDestination });
        } else {
          router.push({ path: this.item.pageDestinationIstitutoMosso });
        }
      }
    },
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.zoom {
  transition: transform 0.2s; /* Animation */
  margin: 0 auto;
  cursor: pointer;
}

.zoom:hover {
  transform: scale(
    1.08
  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.card-img-top {
  width: 100%;
  height: 20rem;
  object-fit: cover;
}

.custom-card {
  width: 20rem;
    margin: 10px;
    border-radius: 10px;

}

.custom-card-img {
  border-radius: 10px 10px 0 0;
}

</style>
